import axiosClient from '../../configs/axios';


class CylinderMasterService {
    // Get list 
    async getCylinderList(params) {
        try {
            const response = await axiosClient.get(
                `/cylinder/get?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    

    // Get list 
    async getintrasitelist(params) {
        try {
            const response = await axiosClient.get(
                `/cylinder/intransit?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

async getCylinderquicksearch(params) {
  try {
    const response = await axiosClient.get('/search/cylinder', {
      params: {
        searchKey: params.searchKey, // only one key
        page: params.page || 1,
        size: params.size || 50,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}




    // Add 
    async addCylinder(data) {
        try {
            const response = await axiosClient.post('/cylinder/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteCylinder(data) {
        try {
            const response = await axiosClient.put(`/cylinder/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new CylinderMasterService(); 